import { createContext, useContext } from 'react';

import type { ActorsCmp_ActorableRules } from '../../../components/Actors/fragments/actorable-rules.fragment';

export type BaseRoleFlags = Pick<
  ActorsCmp_ActorableRules,
  | 'giveBaseRoleToAllInternalUsers'
  | 'giveBaseRoleToAllRelatedInternalOrganizationMembers'
  | 'giveBaseRoleToAllRelatedExternalOrganizationMembers'
>;

// Under a confidential entity, the workflow flags give no Base role.
export const NO_BASE_ROLE_FLAGS: BaseRoleFlags = {
  giveBaseRoleToAllInternalUsers: false,
  giveBaseRoleToAllRelatedInternalOrganizationMembers: false,
  giveBaseRoleToAllRelatedExternalOrganizationMembers: false,
};

export const effectiveBaseRoleFlags = (
  flags: BaseRoleFlags,
  isUnderConfidentiality: boolean,
): BaseRoleFlags => (isUnderConfidentiality ? NO_BASE_ROLE_FLAGS : flags);

const BaseRoleFlagsContext = createContext<BaseRoleFlags | undefined>(
  undefined,
);

export const BaseRoleFlagsProvider = BaseRoleFlagsContext.Provider;

// Whether the workflow gives the Base role to the members of an organization
// acting: the representatives get it whatever their roles (the back adds it
// when checking the rights, it is never stored).
export const useIsBaseRoleGivenToMembers = (
  isInternalOrganization: boolean,
) => {
  const flags = useContext(BaseRoleFlagsContext);

  if (!flags) {
    return false;
  }

  return isInternalOrganization
    ? flags.giveBaseRoleToAllRelatedInternalOrganizationMembers ||
        flags.giveBaseRoleToAllInternalUsers
    : flags.giveBaseRoleToAllRelatedExternalOrganizationMembers;
};
